import { Injectable } from '@angular/core';
import { JeevesActivityInternalCustomerResponsibleService } from 'gung-standard-jeeves';

@Injectable({
  providedIn: 'root'
})
export class CultActivityInternalCustomerResponsibleService extends JeevesActivityInternalCustomerResponsibleService {
  userCustomerResponsiblePath: string = 'extra.salespersonCode';
  useCustomerSalesperson: boolean = false;
}